import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import TimeAgo from "react-timeago";
import { Headline } from "../../atoms/headline";
import Authors from "../../atoms/authors";
import "./verticle-story-card.m.css";
import { dateFormatterWithoutTime } from "../../../utils";
import { getHeroImage, getStoryMetadata } from "../../../utils";
import { ResponsiveImage } from "@quintype/components";

const VerticleStoryCard = ({ story = {}, config = {} }) => {
  const heroS3Key = getHeroImage(story, config);
  return (
    <React.Fragment>
      <figure className="figure">
        <ResponsiveImage
          slug={heroS3Key}
          metadata={getStoryMetadata(story)}
          aspectRatio={[265, 354]}
          defaultWidth={173}
          widths={[173, 265]}
          sizes="( max-width: 500px ) 98%, ( max-width: 768px ) 48%, 23%"
          imgParams={{ auto: ["format", "compress"] }}
          className="responsive-img"
        />
      </figure>
      <Headline story={story} externalLink={true} />
      <div styleName="author-details">
        <Authors story={story} />
        <TimeAgo formatter={dateFormatterWithoutTime} date={story["last-published-at"]} live={false} />
      </div>
    </React.Fragment>
  );
};

VerticleStoryCard.propTypes = {
  story: PropTypes.object,
  config: PropTypes.object
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {})
});

export default connect(mapStateToProps)(VerticleStoryCard);
